import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ToolbarButton } from 'wix-rich-content-editor-common';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var createBlockAlignmentButton = ({ alignment, Icon, tooltipTextKey }) => {
  var _a;
  return _a = class extends Component {
    constructor() {
      super(...arguments);
      __publicField(this, "isActive", () => this.props.alignment === alignment);
      __publicField(this, "handleClick", (event) => {
        var _a2;
        event.preventDefault();
        const { disabled, setLayoutProps, helpers, pluginType } = this.props;
        if (disabled) {
          return;
        }
        (_a2 = helpers == null ? void 0 : helpers.onToolbarButtonClick) == null ? void 0 : _a2.call(helpers, {
          buttonName: "Alignment",
          type: "PLUGIN",
          pluginId: pluginType,
          value: `${alignment}`
        });
        setLayoutProps({ alignment });
      });
      __publicField(this, "preventBubblingUp", (event) => {
        event.preventDefault();
      });
    }
    render() {
      const { disabled, theme, t, tabIndex, keyName } = this.props;
      const className = classNames({
        [theme.button]: true,
        [theme.active]: this.isActive(),
        [theme.disabled]: disabled
      });
      const tooltipText = t(tooltipTextKey);
      const dataHookText = `blockAlignmentButton_${keyName}`;
      const IconComponent = this.props.icon || Icon;
      const blockButton = /* @__PURE__ */ React.createElement("div", { className: theme.buttonWrapper, onMouseDown: this.preventBubblingUp }, /* @__PURE__ */ React.createElement(
        "button",
        {
          tabIndex,
          className,
          "data-hook": dataHookText,
          onClick: this.handleClick
        },
        /* @__PURE__ */ React.createElement("div", { className: theme.icon }, /* @__PURE__ */ React.createElement(IconComponent, null))
      ));
      return /* @__PURE__ */ React.createElement(ToolbarButton, { theme, tooltipText, button: blockButton });
    }
  }, __publicField(_a, "propTypes", {
    alignment: PropTypes.string,
    setLayoutProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    theme: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    tooltipText: PropTypes.string,
    t: PropTypes.func,
    tabIndex: PropTypes.number,
    icon: PropTypes.func,
    keyName: PropTypes.string.isRequired,
    helpers: PropTypes.object,
    pluginType: PropTypes.string
  }), _a;
};

export { createBlockAlignmentButton as default };
//# sourceMappingURL=createBlockAlignmentButton.js.map
